import { fetchEntities } from 'actions/entities';
import EmploymentsListItem from 'components/employments/EmploymentsListItem'
import EntitiesList from 'components/entities/EntitiesList';
import React from 'react'
import { connect } from 'react-redux'


import { getEmployments } from 'selectors/employments'
import { Table } from "semantic-ui-react";


const mapStateToProps = (state, ownProps) => {
  return {
    entities: getEmployments(state, ownProps),
    entityName: 'employment',
    item: EmploymentsListItem,
    listComponent: Table,
    loading: state.meta.employment.loading,
    error: state.meta.employment.error
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchExtraEntities: () => {
      dispatch(fetchEntities('employments'))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList);
